import { getUser } from '../../services/user';
import { USER_RETRIEVED } from './types';
import debounce from 'lodash/debounce';
import signOutAction from './signOutAction';

const debouncedGetUser = debounce(
  async (dispatch) => {
    const { success, user, status } = await getUser();

    if (success) {
      return dispatch({
        type: USER_RETRIEVED,
        payload: { user: user }
      });
    } else {
      if (status == 401) {
        dispatch(signOutAction(dispatch));
      }
      return dispatch({
        type: USER_RETRIEVED,
        payload: { user: {} }
      });
    }
  },
  150,
  { leading: true, trailing: false }
);

const getUserAction = () => debouncedGetUser;

export default getUserAction;
